import { render } from "./browse-top.vue?vue&type=template&id=64396a5f&scoped=true&ts=true"
import script from "./browse-top.vue?vue&type=script&setup=true&lang=ts"
export * from "./browse-top.vue?vue&type=script&setup=true&lang=ts"

import "./browse-top.vue?vue&type=style&index=0&id=64396a5f&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64396a5f"],['__file',"src/layout/components/browse-top.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64396a5f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64396a5f', __exports__)) {
    console.log('reload')
    api.reload('64396a5f', __exports__)
  }
  
  module.hot.accept("./browse-top.vue?vue&type=template&id=64396a5f&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('64396a5f', render)
  })

}


export default __exports__